import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const SilentBookClubs = () => <EventCategoryPage config={EVENT_CATEGORIES['silent-book-clubs']} data-id="element-9881" data-mp="4gyln92ujchk" />;
export default SilentBookClubs;